import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Student } from '../../shared-components/student/student.model';
import { StudentService } from '../../shared-components/student/student.service';
import { System } from '../../shared-components/System';
import { YearService } from '../../shared-components/year/year.service';
import { ProgramAndServiceDetail } from '../../student360/programs-and-services/programs-and-services-detail.model';
import { ProgramAndService } from '../../student360/programs-and-services/programs-and-services.model';
import { ProgramServiceConfig } from '../district/models/program-service.model';

@Injectable({
    providedIn: 'root'
})
export class ProgramAndServiceService {
    // Class Functions
    constructor(
        private yearService: YearService,
        private studentService: StudentService,
        private http: HttpClient,
        private router: Router
    ) {
    }

    // Event Functions

    // Methods
    getProgramsAndServices(viewOption = 0) {
        const siteYearId = (this.router.url.indexOf('registrationEnroll') == -1) ? this.studentService.studentEnrollment.SiteYearId : this.yearService.defaultYear.SiteYearId;
        // POST: obtains the programs and services for the student in the selected year
        const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
            '&yearId=' + this.yearService.student360Year.Id +
            '&siteYearId=' + siteYearId +
            '&viewOption=' + viewOption;
        return this.http.get<ProgramAndService[]>(System.apiURL.Student + 'GetProgramAndServices' + queryString);
    }

    // Methods
    // getProgramCodeLookup() {
    //     // POST: obtains the program code lookup data
    //     const queryString = '?yearId=' + this.yearService.student360Year.Id;
    //     return this.http.get<Lookup[]>(System.apiURL.Admin + 'GetProgramCodeLookups' + queryString);
    // }

    // getServiceCodeLookup(programCodeId: number) {
    //     // POST: obtains the service code lookup data
    //     const queryString = '?programCodeId=' + programCodeId;
    //     return this.http.get<Lookup[]>(System.apiURL.Admin + 'GetProgramServiceCodeLookups' + queryString);
    // }

    getServiceDetailByServiceCodeId(programServiceCodeId: number, programServiceId: number = 0) {
        // POST: obtains the field by serviceCodeId
        const queryString = '?servicesCodeId=' + programServiceCodeId + '&programServiceId=' + programServiceId;
        return this.http.get<ProgramAndServiceDetail[]>(System.apiURL.Student + 'GetProgramAndServicesDetailByServiceCodeId' + queryString);
    }

    // Save Program Codes
    saveProgramAndService(studentId: number, program: ProgramAndService): Observable<boolean> {
        // PRE: a program to add
        // POST: adds that program to the server which returns boolean
        if (program.EntryDate != null && (program.EntryDate.toString() == System.junkDate.toString())) {
            program.EntryDate = null;
        }
        if (program.ExitDate != null && (program.ExitDate.toString() == System.junkDate.toString())) {
            program.ExitDate = null;
        }
        const queryString = '?studentId=' + studentId;
        return this.http.post<boolean>(System.apiURL.Student + 'SaveProgramAndService' + queryString, program);
    }

    // Delete Program Service
    deleteProgramService(programServiceId: number): Observable<boolean> {
        // PRE: a programservice to delete
        // POST: delete programservice from server
        const queryString = '?programServiceId=' + programServiceId;
        return this.http.get<boolean>(System.apiURL.Student + 'DeleteProgramService' + queryString);
    }

    // Mass Delete Program Service
    massDeleteProgramService(programAndServices: ProgramAndService[]): Observable<string> {
        // PRE:  programservices to delete
        // POST: delete programservices from server
        return this.http.post<string>(System.apiURL.Student + 'MassDeleteProgramService', programAndServices);
    }

    getProgramsAndServiceForMassUpdate(schoolId: number, yearId: number, programCodeId: number, serviceCodeId: number) {
        // POST: obtains the programs and services for the student in the selected year
        const queryString = '?schoolId=' + schoolId +
            '&yearId=' + yearId +
            '&programCodeId=' + programCodeId +
            '&serviceCodeId=' + serviceCodeId;
        return this.http.get<ProgramAndService[]>(System.apiURL.Student + 'GetProgramAndServiceForMassUpdate' + queryString);
    }

    massAddProgramAndService(program: ProgramAndService): Observable<string> {
        // PRE: a program to add with multipple student
        // POST: adds that program to the server which returns string
        if (program.EntryDate != null && (program.EntryDate.toString() == System.junkDate.toString())) {
            program.EntryDate = null;
        }
        if (program.ExitDate != null && (program.ExitDate.toString() == System.junkDate.toString())) {
            program.ExitDate = null;
        }
        return this.http.post<string>(System.apiURL.Student + 'MassAddProgramAndService', program);
    }

    massEditProgramAndService(programs: ProgramAndService[]): Observable<string> {
        // PRE: Mass update program and service
        // POST: updates that program to the server which returns string
        programs.forEach(ps => {
            if (ps.EntryDate != null && (ps.EntryDate.toString() == System.junkDate.toString())) {
                ps.EntryDate = null;
            }
            if (ps.ExitDate != null && (ps.ExitDate.toString() == System.junkDate.toString())) {
                ps.ExitDate = null;
            }
        });
        return this.http.post<string>(System.apiURL.Student + 'MassEditProgramAndService', programs);
    }

    getInvalidStudentForSelectedProgramAndServiceCode(programAndService: ProgramAndService) {
        // POST: obtains the list of  invalid student in selected program and services
        if (programAndService.EntryDate != null && (programAndService.EntryDate.toString() == System.junkDate.toString())) {
            programAndService.EntryDate = null;
        }
        if (programAndService.ExitDate != null && (programAndService.ExitDate.toString() == System.junkDate.toString())) {
            programAndService.ExitDate = null;
        }
        return this.http.post<Student[]>(System.apiURL.Student + 'GetInvalidStudentForSelectedProgramAndServiceCode', programAndService);
    }

    // Delete Program Service
    importStudentProgramAndServices(yearId: number, siteId: number, file: string, fileName: string, matchIdOption: number, programServiceOverrideSetting: boolean, programServerOverrideOption: number): Observable<string> {
        // PRE: a programservice to delete
        // POST: delete programservice from server
        const queryString = '?yearId=' + yearId +
            '&siteId=' + siteId +
            '&file=' + file +
            '&fileName=' + fileName +
            '&matchIdOption=' + matchIdOption +
            '&programServiceOverrideSetting=' + programServiceOverrideSetting +
            '&programServerOverrideOption=' + programServerOverrideOption;
        return this.http.get<string>(System.apiURL.Student + 'ImportStudentProgramAndService' + queryString);
    }

    getProgramServiceCodesByUserId(yearId: number, schoolId: number): Observable<ProgramServiceConfig[]> {
        const queryString = '?yearId=' + yearId +
            '&schoolId=' + schoolId;

        return this.http.get<ProgramServiceConfig[]>(System.apiURL.Management + 'GetProgramServiceCodesByUserId' + queryString);
    }
}
